export enum EcomPriceOperatorEnum {
  EqualTo = 0,
  GreaterThan = 1,
  LessThan = 2,
}
